export const ordersDispatchesSubMenu = [{
  path: '/orders-dispatches/list',
  component: () => import('@/views/orders-dispatches/list.vue'),
  name: 'Dispatch',
  meta: {
    title: 'inventoryManagement.dispatch.title',
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Invoice Manager', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Sales Manager', 'Order Manager'],
    noCache: true,
    hidden: false,
    icon: 'truck'
  }
}, {
  path: '/orders-dispatches/add',
  component: () => import('@/views/orders-dispatches/manage.vue'),
  name: 'inventoryManagement.dispatch.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'inventoryManagement.dispatch.add',
    roles: ['Unit Manager'],
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/add/tally',
  component: () => import('@/views/orders-dispatches/components/OrdersDispatchesTally.vue'),
  name: 'inventoryManagement.dispatch.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'inventoryManagement.dispatch.add',
    roles: ['Unit Manager'],
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/info/:id(\\d+)',
  component: () => import('@/views/orders-dispatches/info.vue'),
  name: 'inventoryManagement.dispatch.info',
  props: {
    isEdit: true
  },
  meta: {
    title: 'inventoryManagement.dispatch.info',
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/lr-detail/:id(\\d+)',
  component: () => import('@/views/orders-dispatches/lr-detail.vue'),
  name: 'inventoryManagement.dispatch.lrDetail',
  props: {
    isEdit: true
  },
  meta: {
    title: 'inventoryManagement.dispatch.lrDetail',
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/update-eway/:id(\\d+)',
  component: () => import('@/views/orders-dispatches/update-eway.vue'),
  name: 'inventoryManagement.dispatch.updateEway',
  props: {
    isEdit: true
  },
  meta: {
    title: 'inventoryManagement.dispatch.updateEway',
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/upload-eway-pdf/:id(\\d+)',
  component: () => import('@/views/orders-dispatches/upload-eway-pdf.vue'),
  name: 'inventoryManagement.dispatch.uploadEwayPdf',
  props: {
    isEdit: true
  },
  meta: {
    title: 'inventoryManagement.dispatch.uploadEwayPdf',
    noCache: true,
    activeMenu: '/orders-dispatches/list',
    hidden: true
  }
}, {
  path: '/orders-dispatches/depo-transit-list',
  component: () => import('@/views/orders-dispatches/depo-transit-list.vue'),
  name: 'inventoryManagement.dispatch.depoTransit',
  meta: {
    title: 'inventoryManagement.dispatch.depoTransit',
    roles: ['Super Admin', 'Account Manager', 'Unit Manager', 'Read Only'],
    noCache: true,
    hidden: false,
    icon: 'scale'
  }
}, {
  path: '/orders-dispatches/inbound-dispatch-list',
  component: () => import('@/views/orders-dispatches/inbound-dispatch-list.vue'),
  name: 'inventoryManagement.dispatch.inbound',
  meta: {
    title: 'inventoryManagement.dispatch.inbound',
    roles: ['Super Admin', 'Unit Manager', 'Read Only', 'Zonal Manager', 'Branch Manager'],
    noCache: true,
    hidden: false,
    icon: 'sack'
  }
}];